export enum ContactType {
  Phone = "phone",
  Email = "email",
  Address = "address",
  Url = "url",
}

export type Contacts = Map<ContactType, string | undefined>;
